import { RemoteGetAllPersonActivities } from 'data/usecases';
import { GetAllPersonActivitiesUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPersonActivities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllPersonActivities =
  (): GetAllPersonActivitiesUseCaseInterface =>
    new RemoteGetAllPersonActivities(
      makeApiUrlPersonActivities(),
      makeAxiosHttpClient(),
    );
